import React from 'react';
import {
  Dac7ProfileWrapper,
  StyledLinkParagraph,
  Title,
  Button,
  Text,
  SubTitle,
  BoldText,
  ButtonWrapper,
  RedText,
} from './components/style/Dac7Profile';
import { useI18n } from '../../../../i18n';
import Dac7EyeHiddenTooltip from './components/Dac7EyeHiddenTooltip';

interface Props {
  isBlockable: boolean;
  redirectToForm: () => void;
  learnMore: string;
}

export default ({ isBlockable, redirectToForm, learnMore }: Props) => {
  const i18n = useI18n();

  return (
    <Dac7ProfileWrapper>
      <Title>
        {i18n('dlv_dac7_profile_title_details').toUpperCase()} <Dac7EyeHiddenTooltip />
        <RedText>{i18n('dlv_dac7_profile_payout_paused')}</RedText>
      </Title>
      <SubTitle>{i18n('dlv_dac7_profile_recieve_payout')}</SubTitle>
      <Text>{i18n('dlv_dac7_profile_conditions')}</Text>
      <Text>{i18n('dlv_dac7_profile_regulations')}</Text>
      {!!isBlockable && <BoldText>{i18n('dlv_dac7_profile_required')}</BoldText>}
      <StyledLinkParagraph href={learnMore}>{i18n('dlv_dac7_profile_learn')}</StyledLinkParagraph>
      <ButtonWrapper>
        <Button onClick={redirectToForm}>{i18n('dlv_dac7_profile_fill_form')}</Button>
      </ButtonWrapper>
    </Dac7ProfileWrapper>
  );
};
